import type { MenuProps } from "antd";
import { Dropdown, message, Popover, Space } from "antd";
import { useUserInfo, useUserInfoDispath } from "@/model";
import "./index.less";
import { useCallback, useEffect, useState } from "react";
import Storage from "@/utils/store";
import { loginApi, safetyGasApi } from "@/apis";
import { DownOutlined } from "@ant-design/icons";
import questionnaire from "@/images/home/questionnaire2025.png";
import questionnaireM from "@/images/home/questionnaire-m.png";
import logoPng from "@/images/logo.png";
import menuPng from "@/images/menu.svg";
import { env } from "@/utils/env";
import { useNavigate } from "react-router";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import HeaderModalM from "./headerModalM";

const Header = () => {
  const userInfo = useUserInfo();
  const dispatch = useUserInfoDispath();
  const navigate = useNavigate();
  const isLogin = userInfo.loginInfo && userInfo.curUserInfo;

  const [openPop, setOpenPoP] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [dropdownItem, setDropdownItem] = useState<MenuProps["items"]>([]);
  const [showModalM, setShowModalM] = useState(false);
  const [curStickyInfo, setCurStickyInfo] = useState<SafeyGasList>();

  // 初始化
  useEffect(() => {
    safetyGasApi
      .getSafeyGasList({
        size: 30,
        page: 1,
      })
      .then((res) => {
        if (res?.records) {
          const curStickyInfo = res.records.find((el) => el.isSticky === "Y");
          setCurStickyInfo(curStickyInfo);
        }
      });
  }, []);

  // 初始化在线客服
  const initZhiChi = useCallback((userPhone = "") => {
    if ((window as any).zc) {
      (window as any).zc("dynamic_ready");
    } else {
      (function (w, d, e) {
        const preBtn = d.getElementById("zhichiScript");
        if (preBtn) preBtn.remove();
        (w as any)[e] = function () {
          (w as any).cbk = (w as any).cbk || [];
          (w as any).cbk.push(arguments);
        };
        const x = d.createElement("script");
        x.async = true;
        x.id = "zhichiScript";
        x.className = "zcbtn"; //该class绑定到自定义按钮上 第一步
        x.src = `https://yingde.soboten.com/chat/frame/v2/entrance.js?sysnum=4bcbf303e21b445c92d79db839af3a86&partnerid=${userPhone}`;
        d.body.appendChild(x);
      })(window, document, "zc");
      (window as any).zc("config", {
        time: 10,
        custom: true, //设置自定义生效 第二步
        color: "004098",
        dragging: true,
      });
    }
  }, []);

  useEffect(() => {
    const getFingerprint: (fn: any) => Promise<void> = async (fn) => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        console.log("result.visitorId===", result.visitorId);
        fn(result.visitorId);
      } catch (error) {
        console.log("error=", error);
        const id = Date.now();
        fn(id);
      }
    };

    if (userInfo.curUserInfo) {
      initZhiChi(userInfo.curUserInfo.userPhone);
    } else {
      getFingerprint(initZhiChi);
      // initZhiChi("13800000000");
    }
  }, [initZhiChi, userInfo.curUserInfo]);

  useEffect(() => {
    if (!userInfo.loginInfo || !userInfo.curUserInfo) {
      return;
    }
    // 请求当前用户的公司列表
    if (!userInfo.curUserProductAllList) {
      loginApi
        .findByUserAccount({
          userAccount: userInfo.loginInfo.account,
        })
        .then((res) => {
          dispatch({
            type: "user/seUserProduct",
            data: res,
          });
        })
        .catch((err) => {
          message.error(err);
        });
    }
  }, [
    userInfo.loginInfo,
    userInfo.curUserInfo,
    userInfo.curUserProductAllList,
    dispatch,
  ]);

  useEffect(() => {
    // 多用户下拉框处理
    if (userInfo.curUserProductAllList && userInfo.productGroupDict) {
      const _dropdownItem: MenuProps["items"] = [];
      userInfo.curUserProductAllList.forEach((el) => {
        const obj: any = {
          key: el.custCode,
          type: "group",
          label: el.custName,
          children: [],
        };
        el.userVoList.forEach((item) => {
          obj.children.push({
            key: item.userAccount,
            label:
              userInfo.productGroupDict?.[item.productGroup]?.dictValue ||
              item.productGroup,
          });
        });
        _dropdownItem.push(obj);
      });
      setDropdownItem(_dropdownItem);
      const hiddenTooltip = Storage.s.get("hiddenTooltip");
      if (_dropdownItem.length > 1 && !hiddenTooltip) {
        setOpenPoP(true);
      }
    }
  }, [userInfo.curUserProductAllList, userInfo.productGroupDict]);

  useEffect(() => {
    if (dropdownItem && dropdownItem.length > 1 && userInfo.isPhoneLogin) {
      setOpenDropdown(true);
    }
  }, [dropdownItem, userInfo.isPhoneLogin]);

  const getMenuList = useCallback(
    (account: string) => {
      loginApi
        .findMenuListByUserAccount({
          userAccount: account,
        })
        .then((res = []) => {
          // 只要第一级的服务中心内的数据
          const serviceMenuList = res.filter((el) => el.comment === "服务中心");
          Storage.l.set("serviceMenuItems", serviceMenuList[0]);
          dispatch({
            type: "user/setMenuList",
            data: serviceMenuList[0],
          });
        })
        .catch((err) => {
          message.error(err);
        });
    },
    [dispatch]
  );

  // 获取当前用户的权限列表
  useEffect(() => {
    if (!userInfo.loginInfo || !userInfo.curUserInfo) {
      return;
    }
    if (!userInfo.serviceMenuItems) {
      getMenuList(userInfo.curUserInfo.userAccount);
    }
  }, [
    userInfo.loginInfo,
    userInfo.curUserInfo,
    userInfo.serviceMenuItems,
    getMenuList,
  ]);

  const handleLoginOquit = () => {
    setShowModalM(false);
    Storage.s.clear();
    setDropdownItem([]);

    const whitelist = ["productGroupDict"];
    const _savaObj: any = {};
    whitelist.forEach((el) => {
      _savaObj[el] = Storage.l.get(el);
    });
    Storage.l.clear();
    for (const [key, value] of Object.entries(_savaObj)) {
      Storage.l.set(key, value);
    }

    let type = "login/open";
    if (isLogin) {
      type = "login/quit";
    }
    dispatch({ type });
  };

  const handeDropdownChange = (open: boolean) => {
    if (
      !loading &&
      dropdownItem &&
      (dropdownItem.length > 1 ||
        (dropdownItem[0] as any)?.children?.length > 1)
    ) {
      setOpenDropdown(open);
    }
  };

  const onSelect: MenuProps["onSelect"] = async ({ key }) => {
    setLoading(true);
    setOpenDropdown(false);
    setShowModalM(false);

    try {
      let _accountListInfo: any = {};
      userInfo.curUserProductAllList?.forEach(({ userVoList }) => {
        userVoList &&
          userVoList.forEach((el) => {
            const { userAccount } = el;
            if (userAccount === key) {
              _accountListInfo = el;
            }
          });
      });

      // 重新登录
      const res = await loginApi.changeUserCurrentCustomer({
        customerCode: _accountListInfo.customerCode,
        userName: _accountListInfo.userAccount,
      });
      const { jwt } = res;
      setLoading(false);
      // 当前客户信息
      const _loginInfo = Storage.l.get("loginInfo") || {};
      _loginInfo.jwt = jwt;

      Storage.l.set("curUserInfo", _accountListInfo);
      dispatch({
        type: "user/setUserInfo",
        loginInfo: _loginInfo,
        curUserInfo: _accountListInfo,
      });
      getMenuList(_accountListInfo.userAccount);
    } catch (error: any) {
      message.error(error);
      setLoading(false);
    }
  };

  const cancelTips = useCallback(() => {
    Storage.s.set("hiddenTooltip", true);
    setOpenPoP(false);
  }, []);

  const goQuestionnaire = useCallback(() => {
    window.open("https://wj.qq.com/s2/23689199/c6k9/");
  }, []);

  const goHome = () => {
    navigate("/home");
  };

  const goPage = () => {
    navigate(`/safetyGas/safetyGasDetail/${curStickyInfo?.id}`);
  };

  return (
    <>
      <article className="reset-ele header-container">
        <img
          className="questionnaire-png"
          onClick={goQuestionnaire}
          src={env.isMobile ? questionnaireM : questionnaire}
          alt=""
        />
        <div className="max-width">
          {env.isMobile ? (
            // 移动端
            <div className="header-info-m">
              <img src={logoPng} onClick={goHome} alt="" />
              <img
                className="menu"
                src={menuPng}
                onClick={() => setShowModalM(true)}
                alt=""
              />
            </div>
          ) : (
            <div className="header-info flex-b-c">
              <p>您好，欢迎来到盈德气体商城！服务热线：400-921-1717</p>
              {curStickyInfo ? (
                <span className="remind-info" onClick={goPage}>
                  {curStickyInfo.title}
                </span>
              ) : null}
              <div className="flex">
                <span className="user-company">
                  {!isLogin && "游客"}
                  {isLogin && (
                    <Popover
                      content={
                        <div className="tips-pop">
                          点击此处可切换您的公司及其产品
                          <span onClick={cancelTips}>我知道了</span>
                        </div>
                      }
                      placement="bottom"
                      trigger="click"
                      open={openPop}
                    >
                      <Dropdown
                        open={openDropdown}
                        onOpenChange={handeDropdownChange}
                        trigger={["click"]}
                        placement="bottom"
                        arrow
                        menu={{
                          items: dropdownItem,
                          onSelect,
                          selectable: true,
                          defaultSelectedKeys: [
                            userInfo.curUserInfo?.userAccount || "",
                          ],
                          rootClassName: "dropdown-menu-content",
                        }}
                      >
                        <Space>
                          <span>{userInfo.curUserInfo?.customerName}</span>
                          {dropdownItem && dropdownItem.length > 1 && (
                            <DownOutlined />
                          )}
                        </Space>
                      </Dropdown>
                    </Popover>
                  )}
                </span>
                <span className="user-spline"></span>
                <span className="user-quit" onClick={handleLoginOquit}>
                  {isLogin ? "退出" : "登录"}
                </span>
              </div>
            </div>
          )}
        </div>
        {showModalM ? (
          <HeaderModalM
            setShowModalM={setShowModalM}
            isLogin={isLogin}
            dropdownItem={dropdownItem}
            onSelect={onSelect}
            handeDropdownChange={handeDropdownChange}
            openDropdown={openDropdown}
            userInfo={userInfo}
            handleLoginOquit={handleLoginOquit}
          />
        ) : null}
      </article>
    </>
  );
};

export default Header;
